import { axios } from 'utils/networkRequests';
import useSnackbar from 'hooks/useSnackbar';
import { useHistory } from 'react-router';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';

const useSetPassword = () => {
  const history = useHistory();
  const snackbar = useSnackbar();
  const [{ token }] = useQueryParams({
    token: withDefault(StringParam, ''),
  });

  return async ({ password }) => {
    try {
      await axios.post(`/v3/professional/accounts/reset_password`, {
        account: {
          password,
          token,
        },
      });
      snackbar.success('Your password has been succesfully updated');
      history.push('/login');
    } catch (e) {
      snackbar.error(e);
    }
  };
};

export default useSetPassword;
